import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/people2.png'
import _imports_1 from '@/assets/people1.png'


const _hoisted_1 = { class: "complete_body" }
const _hoisted_2 = { class: "btns" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "comment_title" }, [
      _createElementVNode("i", { class: "sparkle_left" }),
      _createElementVNode("p", null, "2026 하반기"),
      _createElementVNode("p", null, "액션시민 모집 중 !!!"),
      _createElementVNode("i", { class: "sparkle_right" })
    ], -1)),
    _createElementVNode("div", _hoisted_1, [
      _cache[2] || (_cache[2] = _createElementVNode("div", null, [
        _createElementVNode("p", null, "성매매 문제의 구조를 이해하고"),
        _createElementVNode("p", null, [
          _createTextVNode(" 반성매매 액션에 함께 할 "),
          _createElementVNode("span", null, "<액션시민>을 찾습니다.")
        ]),
        _createElementVNode("br"),
        _createElementVNode("p", null, "‘반성매매 시민참여 플랫폼’ 접속 후"),
        _createElementVNode("p", null, [
          _createElementVNode("span", { class: "info" }, "[시민참여 활동]>[반성매매 시민활동]"),
          _createTextVNode(" 에서 신청가능!!! ")
        ])
      ], -1)),
      _cache[3] || (_cache[3] = _createElementVNode("p", null, "* 개인정보를 입력하신 후에 캠페인 참여가 완료됩니다.", -1)),
      _createElementVNode("button", {
        id: "complete_btn",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.complete && $setup.complete(...args)))
      }, "캠페인 참여 완료하러 가기")
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        id: "prev",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.prev && $setup.prev(...args)))
      }, "이전")
    ]),
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "footer_bg" }, [
      _createElementVNode("div", { class: "icon_wrap" }, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: ""
        }),
        _createElementVNode("img", {
          src: _imports_1,
          alt: ""
        })
      ])
    ], -1))
  ], 64))
}